import(/* webpackMode: "eager" */ "/home/runner/work/sigma-labs/sigma-labs/platform/app/global-error.tsx");
